export const getTenantInputs = (
  buildingOptions,
  propertyOptions,
  selectedBuildingId,
  intervalOptions,
  tenantType
) => {
  const buildingIdNum = Number(selectedBuildingId);

  const filteredPropertyOptions = propertyOptions
    .filter((p) => p.building_id === buildingIdNum)
    .map((p) => ({
      value: p.id.toString(),
      label: p.property_name,
    }));

  return [
    {
      _key: "tenant_first_name",
      _name: "First Name",
      _type: "text",
      _placeholder: "First Name",
      _helperText: "Please enter first name",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "tenant_last_name",
      _name: "Last Name",
      _type: "text",
      _placeholder: "Last Name",
      _helperText: "Please enter last name",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "tenant_contact",
      _name: "Contact",
      _type: "text",
      _placeholder: "Phone Number",
      _helperText: "Please enter Phone Number",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "uid_number",
      _name: "Aadhar/PAN Number",
      _type: "text",
      _placeholder: "Aadhar Number",
      _helperText: "Please enter Aadhar Number",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "building_id",
      _name: "Building",
      _type: "dynamic-drop-down",
      _placeholder: "Building Name",
      _helperText: "Please select building",
      _mandatory: true,
      _options: buildingOptions,
      _gridSize: 6,
    },
    {
      _key: "property_id",
      _name: "Property",
      _type: "dynamic-drop-down",
      _placeholder: "Property",
      _helperText: "Please select Property",
      _mandatory: true,
      _options: filteredPropertyOptions,
      _gridSize: 6,
      _disabled: !selectedBuildingId,
    },
    {
      _key: "entry_date",
      _name: "Entry Date",
      _type: "date",
      _placeholder: "Entry Date",
      _helperText: "Please enter Entry Date",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "exit_date",
      _name: "Exit Date",
      _type: "date",
      _placeholder: "Exit Date",
      _helperText: "Please enter Exit Date",
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "annual_increment_type",
      _name: "Annual Increment Type",
      _type: "dynamic-drop-down",
      _placeholder: "Annual Increment Type",
      _helperText: "Please enter Annual Increment Type",
      _options: intervalOptions,
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "annual_increment_date",
      _name: "Annual Increment Date",
      _type: "date",
      _placeholder: "Annual Increment Date",
      _helperText: "Please enter Annual Increment Date",
      _mandatory: false,
      _options: {
        readOnly: true,
      },
      _gridSize: 6,
    },
    {
      _key: "tenant_type",
      _name: "Tenant Type",
      _type: "dynamic-drop-down",
      _placeholder: "Tenant Type",
      _helperText: "Please enter tenant Type",
      _options: tenantType,
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "is_gst_check",
      _name: "GST",
      _type: "checkbox",
      _placeholder: "GST",
      _helperText: "Is GST applied?",
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "rent_amount",
      _name: "Rent Amount",
      _type: "amount",
      _placeholder: "Rent Amount",
      _helperText: "Please enter rent amount",
      _mandatory: true,
      _gridSize: 6,
    },
    {
      _key: "maintenance_charges",
      _name: "Maintenance Charges",
      _type: "amount",
      _placeholder: "Maintenance Charges",
      _helperText: "Enter maintenance charges",
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "electricity_per_unit_charge",
      _name: "Electricity Per Unit Charge",
      _type: "number",
      _placeholder: "Electricity Per Unit Charge",
      _helperText: "Enter electricity charge",
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "monthly_electricity_bill",
      _name: "Monthly Electricity Bill",
      _type: "amount",
      _placeholder: "Monthly Electricity Bill",
      _helperText: "Enter Monthly Electricity Bill",
      _mandatory: false,
      _gridSize: 6,
    },
    {
      _key: "notes",
      _name: "Notes",
      _type: "text",
      _placeholder: "Notes",
      _helperText: "Additional notes",
      _mandatory: false,
      _options: {
        multiline: true,
        rows: 2,
      },
      _gridSize: 6,
    },
    {
      _key: "total_rent_amount",
      _name: "Total Rent Amount",
      _type: "amount",
      _placeholder: "Total Rent Amount",
      _helperText: "Auto-calculated",
      _mandatory: true,
      _options: {
        readOnly: true,
      },
      _gridSize: 12,
    },
  ];
};
